import { createFileRoute } from "@tanstack/react-router";
import { alternateLinkList } from "@/lib/i18n/locale";
import { AffiliateGlobalPage } from "./legal.affiliate-global";

export const Route = createFileRoute("/vi/legal/affiliate-global")({
  head: () => ({
    meta: [{ title: "Chương trình Affiliate (Toàn cầu) — Banana Cards" }],
    links: alternateLinkList("/legal/affiliate-global", "vi"),
  }),
  component: AffiliateGlobalPage,
});